<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        :options="options"
        :error="error"
        :loading="loading"
        @filter="filterFn"
        emit-value
        map-options
    >
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
                <q-item-section>
                    <q-item-label>{{ scope.opt.description }}</q-item-label>
                    <!-- <q-item-label caption>{{
                        scope.opt.description
                    }}</q-item-label> -->
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import CondicionPagoService from "@/services/CondicionPagoService";

const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
let defaultOptions = [];
const filterFn = (val, update) => {
    update(() => {
        const needle = val.toLowerCase();
        options.value = defaultOptions.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1
        );
    });
};
onMounted(async () => {
    loading.value = true;
    defaultOptions = await CondicionPagoService.index();
    options.value = defaultOptions;
    loading.value = false;
});
</script>
